import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Canonical class-name combinator for crucible-ui (shadcn/ui
 * convention): `clsx` for conditional composition, `tailwind-merge`
 * so later Tailwind utilities win over earlier conflicting ones
 * (e.g. a caller's `px-4` overrides a variant's `px-3` instead of
 * both landing in the class list with unspecified precedence).
 *
 * Both deps were already in package.json (installed alongside the
 * Radix primitives) — this file is the first consumer. New shared
 * primitives under `components/ui/` MUST use this instead of bare
 * template-string class concatenation. See
 * `docs/design/design-system.md`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
